module.exports = __webpack_public_path__ + "img/logo_SFG_193x34.8255c432.svg";